<div class="mb-3">
  <div class="mat-title-medium">
    {{ item?.title }}
  </div>
  <div class="text-gray mat-title-small">
    {{ item?.created_at | date : 'dd.MM.yyyy hh:mm' }}
  </div>
</div>

<markdown class="news-item-content" [data]="item?.content"></markdown>
